module.exports = __webpack_public_path__ + "files/c7fe6d77f03fb9de22c86f28209db1cd.png";